import { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiBox, MiBuildPageHeader } from "@miplatform/components";
import { getFullName } from "@miplatform/utils";
import { ContactsListSection, MiContactCard } from "@mibuildweb/components";
import { Box } from "@mui/material";

export const AccountUsersTab = ({ accountDetail }) => {
  const { classes } = useStyles();
  const [search, setSearch] = useState("");

  const handleSearch = ({ target: { value } }) => setSearch(value);

  const renderContactCard = (contact) => (
    <Box key={`${contact.id}${contact.level}${contact.label}`}>
      <MiContactCard
        isPrimaryDisabled
        contact={contact}
        accountId={contact.accountId}
      />
    </Box>
  );

  return (
    <MiBox height="100%">
      <MiBuildPageHeader
        title="Users"
        hasDivider={false}
        titleFontSize={18}
        searchPlaceholder="Search user"
        onHandleSearch={handleSearch}
      />
      <Box className={classes.content}>
        {accountDetail?.resources
          ?.map((res) => ({
            ...res,
            users: res.users.filter((user) =>
              getFullName(user.firstName, user.lastName)
                .toLowerCase()
                .includes(search.trim().toLowerCase())
            ),
          }))
          .filter((res) => res.users?.length !== 0)
          .map((res) => (
            <ContactsListSection
              key={res.resourceId}
              items={res.users}
              header={res.name}
              showPrimaryToggle={false}
              renderCard={renderContactCard}
            />
          ))}
      </Box>
    </MiBox>
  );
};

const useStyles = makeStyles()((theme) => ({
  content: {
    display: "grid",
    gridTemplateColumns: `repeat(auto-fit, minmax(max(330px, 48%), 1fr))`,
    gap: theme.spacing(4),
    overflow: "auto",
  },
}));
